module.exports = __webpack_public_path__ + "static/media/barcode.e97d1ee0.svg";